// extracted by mini-css-extract-plugin
export default {"textAbout":"textAbout_textAbout__ziQwj","title":"textAbout_title__HwC39","description":"textAbout_description__ggbq2"};